import React, { useState, useCallback } from 'react';
import {
  Box, Tab, Tabs, Container, Typography, Button, TextField,
} from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import GridViewIcon from '@mui/icons-material/GridView';
import { useUser } from '../../providers/UserProvider';
import style from './Landing.module.scss';
import ListView from './ListView/ListView';
import { useProjects } from '../../providers/ProjectProvider';
import PageLoader from '../../common/PageLoader';
import GridView from './GridView/GridView';
import { getRequest } from '../../utils/apiRequest';
import { auth } from '../../firebase';

const CustomTabPanel = (props) => {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 3 }}>
        {children}
      </Box>
    </div>
  );
};

const Landing = () => {
  const { user } = useUser();
  const {
    loading, count, search, setSearch, urls,
  } = useProjects();
  const showGrid = count > 1;
  const showList = count > 1;
  const [tab, setTab] = useState('list');
  const [redirecting, setRedirecting] = useState(false);

  const handleChange = useCallback((event, newValue) => {
    setTab(newValue);
  }, []);

  const handleDecor = useCallback(() => {
    // eslint-disable-next-line max-len
    window.location.href = `${window.location.protocol}//decormanager.${window.location.hostname.split('.').splice(1).join('.')}${window.location.port ? `:${window.location.port}` : ''}`;
  }, []);

  const handleNavigate = useCallback(async (builderId) => {
    setRedirecting(true);
    const token = await auth.currentUser.getIdToken();
    const realBID = builderId.replace('---pdi', '');
    const resp = await getRequest(
      process.env.REACT_APP_DECORMANAGER_BUILDER_ID,
      token,
      'auth/user/token',
      { requested_builder_id: realBID },
    );

    window.location.assign(`${urls[builderId]}?authToken=${resp.data.authToken}`);
  }, [urls]);

  if (loading) {
    return <PageLoader loadingMessage="Loading Projects" />;
  }

  if (redirecting) {
    return <PageLoader loadingMessage="Logging in" />;
  }

  return (
    <Container fixed maxWidth="lg">
      <Box>
        <Box
          sx={
            {
              borderBottom: 1,
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 6,
            }
          }
        >
          <Box sx={{ marginRight: 'auto' }}>
            <Typography variant="h4">Select a project</Typography>
            <Typography variant="body2" sx={{ color: '#888' }}>
              Welcome back, {user.firstName || user.email}!
            </Typography>
          </Box>
          {
            (showGrid && showList) && (
              <Tabs value={tab} onChange={handleChange} sx={{ marginRight: 1 }}>
                <Tab value="grid" label={<GridViewIcon />} />
                <Tab value="list" label={<FormatListBulletedIcon />} />
              </Tabs>
            )
          }
          {
            user.isAdmin && (
              <Button color="primary" onClick={handleDecor}>Decor Manager</Button>
            )
          }
        </Box>
        {
          showGrid && (
            <CustomTabPanel value={tab} index="grid">
              {
                showList && (
                  <TextField className={style.search} placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
                )
              }
              <GridView handleNavigate={handleNavigate} />
            </CustomTabPanel>
          )
        }
        {
          showList && (
            <CustomTabPanel value={tab} index="list">
              <TextField className={style.search} placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
              <ListView handleNavigate={handleNavigate} />
            </CustomTabPanel>
          )
        }
      </Box>
    </Container>
  );
};

export default Landing;
